import { render, staticRenderFns } from "./SidPosition.vue?vue&type=template&id=2fb71f43"
import script from "./SidPosition.vue?vue&type=script&lang=js"
export * from "./SidPosition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports